import { Filter } from '@anytag/shared-molecules';
import { useXhsInfluencersContext } from '../XhsInfluencersContext';
import { BasicFilter } from './BasicFilter';

export const XhsInfluencersFilter = () => {
  const { filter, setFilter, isEngagementPage, isPackagePage } = useXhsInfluencersContext();

  return (
    <Filter.Provider onSubmit={setFilter} values={filter} className="rounded-none">
      <BasicFilter isEngagementPage={isEngagementPage} isPackagePage={isPackagePage} />
    </Filter.Provider>
  );
};
